import React from 'react'
import { SFormElement } from "#components/SForm";
import { useControllableValue } from 'ahooks'
import classNames from 'classnames/bind';
import styles from './index.less';
import { AmountOrderWrapper } from '#components/AmountOrder';

const cx = classNames.bind(styles);

type DiscountAmountProps = {
    value?: {
        value: number;
        currency: string;
    };
    onChange?: (value: { value: number; currency: string }) => void;
} & React.ComponentProps<typeof SFormElement>;

const DiscountAmount = (props) => {
    const { ...restProps } = props;
    const [state, setState] = useControllableValue(props, {
        defaultValue: {
            value: 0,
            currency: '',
        }
    })
    return <div className={state?.value < 0 ? cx('error-tip') : ""}>
        <SFormElement
            view={true}
            componentClass='currencyType'
            formItemKey='discount_amount'
            key='discount_amount'
            value={state}
            {...restProps}
        />
        {state?.value < 0 && <div style={{ fontSize: 12 }}>{'优惠金额需>=0'}</div>}
    </div>
}

export default DiscountAmount;